var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ax-filesystem-viewer-header"},[_c(_vm.actionsComponent,{tag:"Component",attrs:{"item":_vm.node,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }